import styled from 'styled-components'

export const PageTitleText = styled.p<{ light?: boolean }>`
	font-size: 25px;
	font-weight: 800;
	text-transform: uppercase;
	text-align: center;
	color: #001644;
	margin: 20px 0;
	
	@media all and (min-width: 992px) {
		color: ${({ light }) => light ? '#FFF' : '#001644'};
	}
`
